import { When } from 'react-if';
import { useModal } from '@ebay/nice-modal-react';
import cns from 'classnames';
import { isNil } from 'lodash-es';
import { useTranslation } from 'next-i18next';
import { useDialog } from '@zep/dialog';
import { Button, Stack } from '@zep/ui';
import { RegisterZipCodeModal } from '../paymentForm/ZipCodeInputModal';
import { usePlanSpaceDetailContext } from '../plan';
import { PlanSpaceGroup } from '../space';
import S from './AppliedPlan.module.scss';
export const ZipCode = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const dialog = useDialog();
  const modal = useModal(RegisterZipCodeModal);
  const {
    spacePlan,
    billingInfo,
    refetchPlanDetails
  } = usePlanSpaceDetailContext();
  const zipCodeExists = !!billingInfo?.zipCode || !isNil(billingInfo?.zipCode);
  const showMutateZipCode = async () => {
    await modal.show({
      spaceHashId: spacePlan?.spaceHashId,
      zipCode: isNil(billingInfo?.zipCode) ? '' : billingInfo?.zipCode,
      onSuccess: async () => {
        await refetchPlanDetails();
        modal.remove();
      },
      onError: async () => {
        await dialog.alert({
          title: t('subscription:errorModal.zipCode.title'),
          content: t('subscription:errorModal.zipCode.content')
        });
        modal.remove();
      }
    });
  };
  return <PlanSpaceGroup title={t('subscription:invoice.zipCode.dtTitle')} data-sentry-element="PlanSpaceGroup" data-sentry-component="ZipCode" data-sentry-source-file="ZipCode.tsx">
      <Stack gap={8} data-sentry-element="Stack" data-sentry-source-file="ZipCode.tsx">
        <When condition={zipCodeExists} data-sentry-element="When" data-sentry-source-file="ZipCode.tsx">
          <Stack direction={'row'} gap={8} style={{
          alignItems: 'center'
        }} data-sentry-element="Stack" data-sentry-source-file="ZipCode.tsx">
            <label className={cns(S.label, S.gray)}>
              {billingInfo?.zipCode}
            </label>
          </Stack>
        </When>
        <Stack gap={8} style={{
        alignItems: 'flex-start'
      }} data-sentry-element="Stack" data-sentry-source-file="ZipCode.tsx">
          <Button variant={'sub'} size={'xs'} onClick={showMutateZipCode} data-sentry-element="Button" data-sentry-source-file="ZipCode.tsx">
            {zipCodeExists ? t('subscription:SpaceDetail.zipCode.changeText') : t('subscription:SpaceDetail.zipCode.enterText')}
          </Button>
        </Stack>
      </Stack>
    </PlanSpaceGroup>;
};